module.exports = "#define GLSLIFY 1\nvarying vec2 vUv;\n\nvoid main(){\n    vUv=uv;\n    gl_Position=vec4(position,1.);\n}"